<template>
  <transition name="slide-down">
    <div v-if="isOpen" class="absolute top-0 left-0 right-0 z-50">
      <!-- Minimized State (Bar) -->
      <div
        v-if="isMinimized"
        class="dark:bg-gray-800 bg-blue-gray-900 text-white p-2 flex justify-between items-center shadow-md"
      >
        <span class="truncate max-w-xs">Video Player</span>
        <div class="flex space-x-2">
          <button @click="toggleMinimize" class="p-1 hover:bg-gray-700 rounded">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-5 w-5"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fill-rule="evenodd"
                d="M5 10a1 1 0 011-1h8a1 1 0 110 2H6a1 1 0 01-1-1z"
                clip-rule="evenodd"
              />
            </svg>
          </button>
          <button @click="closeModal" class="p-1 hover:bg-gray-700 rounded">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-5 w-5"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fill-rule="evenodd"
                d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                clip-rule="evenodd"
              />
            </svg>
          </button>
        </div>
      </div>

      <!-- Expanded State (Full Modal) -->
      <div
        v-else
        class="bg-white w-full max-w-full shadow-xl rounded-b-lg overflow-hidden"
      >
        <div
          class="dark:bg-gray-800 bg-blue-gray-900 text-white p-2 flex justify-between items-center"
        >
          <span>Video Player</span>
          <div class="flex space-x-2">
            <button
              @click="toggleMinimize"
              class="p-1 hover:bg-gray-700 rounded"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-5 w-5"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fill-rule="evenodd"
                  d="M5 10a1 1 0 011-1h8a1 1 0 110 2H6a1 1 0 01-1-1z"
                  clip-rule="evenodd"
                />
              </svg>
            </button>
            <button @click="closeModal" class="p-1 hover:bg-gray-700 rounded">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-5 w-5"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fill-rule="evenodd"
                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                  clip-rule="evenodd"
                />
              </svg>
            </button>
          </div>
        </div>

        <div class="aspect-[16/3] portrait:aspect-[16/9]">
          <iframe
            :src="youtubeEmbedUrl"
            title="YouTube Video"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
            class="w-full h-full"
          ></iframe>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "YoutubeModal",
  props: {
    videoUrl: {
      type: String,
      required: true,
    },
    open: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isMinimized: false,
    };
  },
  emits: ["update:open"],
  computed: {
    isOpen: {
      get() {
        return this.open;
      },
      set(val) {
        this.$emit("update:open", val);
      },
    },
    youtubeEmbedUrl() {
      const match = this.videoUrl.match(
        /(?:youtube\.com\/watch\?v=|youtu\.be\/)([^\s&]+)/
      );
      const videoId = match ? match[1] : "";
      return `https://www.youtube.com/embed/${videoId}?autoplay=1`;
    },
  },
  methods: {
    closeModal() {
      this.isOpen = false;
      this.isMinimized = false; // Reset minimized state when closing
    },
    toggleMinimize() {
      this.isMinimized = !this.isMinimized;
    },
  },
};
</script>

<style scoped>
.slide-down-enter-active,
.slide-down-leave-active {
  transition: all 0.3s ease;
}
.slide-down-enter-from,
.slide-down-leave-to {
  transform: translateY(-100%);
  opacity: 0;
}
</style>
